"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReusableTexts;
(function (ReusableTexts) {
    ReusableTexts["identifyingVehicleText"] = "Identificando el veh\u00EDculo\u2026";
})(ReusableTexts || (ReusableTexts = {}));
exports.default = ReusableTexts;
